namespace GeniuzPOS.Inventory {
    export interface LookupIcSoLookupRow {
        SysDocNo?: string;
        DocNo?: string;
        StockFrom?: string;
    }

    export namespace LookupIcSoLookupRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.LookupIcSoLookup';
        export const lookupKey = 'Inventory.LookupIcSoLookup';

        export function getLookup(): Q.Lookup<LookupIcSoLookupRow> {
            return Q.getLookup<LookupIcSoLookupRow>('Inventory.LookupIcSoLookup');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            StockFrom = "StockFrom"
        }
    }
}
